import { createAction, props } from "@ngrx/store";
import { BauteilWithReports, FrontendReport } from "@partikelart/portal/shared-typing";

export const loadPartsForUser = createAction("[Export] Load Parts for User");

export const loadPartsForArrayOfUsers = createAction(
	"[Export] Load Parts for Array of Users",
	props<{ siteIds: string[] }>(),
);

export const downloadReportsForPart = createAction(
	"[Export] Download Reports for Part",
	props<{ partNumber: string }>(),
);
export const updateSelectionForSelectedPart = createAction(
	"[Export] Select or Deselect a Part",
	props<{ partNumber: string; selection: boolean }>(),
);

export const updateSelectionForAllParts = createAction(
	"[Export] Select or Deselect all Parts",
	props<{ selection: boolean }>(),
);

export const downloadReportForPartSuccess = createAction(
	"[Export] Load Reports for Parts Success",
	props<{ partNumber: string; reports: FrontendReport[] }>(),
);

export const downloadReportForPartFailure = createAction(
	"[Export] Load Reports For Parts Failure",
	props<{ error: any }>(),
);

export const loadExportsSuccess = createAction(
	"[Export] Load Exports Success",
	props<{ partsForUser: BauteilWithReports[] }>(),
);

export const loadExportsFailure = createAction("[Export] Load Exports Failure", props<{ error: any }>());
export const getAllReportForSelectedParts = createAction("[Export] Fetch All Reports for all selected parts");
export const getAllReportsForSelectedPartsSuccess = createAction(
	"[Export] Load Reports For All Parts Success",
	props<{ arrayofReports: FrontendReport[][] }>(),
);
export const getAllReportsForSelectedPartsFailure = createAction(
	"[Export] Load Reports for All Parts Failure",
	props<{ error: any }>(),
);
